import { render, staticRenderFns } from "./shelfTask.vue?vue&type=template&id=9aa51888&scoped=true&"
import script from "./shelfTask.vue?vue&type=script&lang=js&"
export * from "./shelfTask.vue?vue&type=script&lang=js&"
import style0 from "./shelfTask.vue?vue&type=style&index=0&id=9aa51888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa51888",
  null
  
)

export default component.exports